import { ONE_MILLISECOND, roundToMilliseconds } from '.';

export function getNextValidStart(endTime: number): number {
	return roundToMilliseconds(endTime + ONE_MILLISECOND);
}

export function getAvailableSpace(end1: number, start2: number): number {
	const nextValidStart = getNextValidStart(end1);
	const space = start2 - nextValidStart;
	return Math.max(0, roundToMilliseconds(space));
}

export function toVisualEndTime(startTime: number, duration: number): number {
	return roundToMilliseconds(startTime + duration - ONE_MILLISECOND);
}

export function getDurationFromInterval(startTime: number, endTime: number): number {
	return roundToMilliseconds(endTime - startTime + ONE_MILLISECOND);
}
